module.exports = __webpack_public_path__ + "static/GraphiQL-911c63ec1d9fc85d25fea4909d98137c.png";